import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PermOfferModalComponent } from '../../submittals/am-submittal-status-update/perm-offer-modal/perm-offer-modal.component';
import { ComponentType } from '@angular/cdk/overlay';
import { PermInterviewModalComponent } from '../../submittals/am-submittal-status-update/perm-interview-modal/perm-interview-modal.component';
import { PermOfferBillingUpdateModalComponent } from '../../submittals/am-submittal-status-update/perm-offer-billing-update-modal/perm-offer-billing-update-modal.component';
import { PermPostOfferConfirmNotStartingModalComponent } from '../../submittals/am-submittal-status-update/perm-post-offer-confirm-not-starting-modal/perm-post-offer-confirm-not-starting-modal.component';

type ValidPostOfferWorkflowModals =
    | PermOfferModalComponent
    | PermInterviewModalComponent
    | PermOfferBillingUpdateModalComponent
    | PermPostOfferConfirmNotStartingModalComponent;

@Injectable({
    providedIn: 'root'
})
export class PermPostOfferWorkflowModalManagerService {
    private modalReference: MatDialogRef<unknown, unknown>;

    constructor(private readonly _dialog: MatDialog) {}

    public createModal<T extends ValidPostOfferWorkflowModals, TPayload>(
        modalComponent: ComponentType<T>,
        payload: TPayload,
        maxWidth: string,
        minWidth: string
    ): void {
        if (this.modalReference) {
            return;
        }

        this.modalReference = this._dialog.open(modalComponent, {
            panelClass: 'status-update-dialog',
            maxWidth: maxWidth,
            minWidth: minWidth,
            disableClose: true,
            data: payload
        });
    }

    public closeModal(): void {
        if (!this.modalReference) {
            return;
        }

        this.modalReference.close();
        this.modalReference = null;
    }
}
